import ELocale from '../../../types/locales'

export default function removePhonePrefix(target: string) {
  return target.replace(/-/g, ' ').replace(/^ *\+\d{2} ?/, '0')
}
